import { Institute } from './../../models/institute/randomInstituteResponse';
import { InstituteService } from './../../services/institute/institute.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ImageModule } from 'primeng/image';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { RouterModule } from '@angular/router';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { RatingModule } from 'primeng/rating';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ChartModule } from 'primeng/chart';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ActivatedRoute } from '@angular/router';
import { Store, Selector, Select } from '@ngxs/store';
import { MyInstitutesSelectors } from '../../states/myInstitutes/my-institute-selector';
import { AddMyInstitute, RemoveMyInstitute } from '../../states/myInstitutes/my-institute-actions';
import { Observable, take } from 'rxjs';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { InstituteDetailSelectors } from '../../states/institutedetail/institute-detail-selector';
import { InstituteDetailModel } from '../../states/institutedetail/institute-detail-model';
import { AddInstituteDetail } from '../../states/institutedetail/institute-detail-actions';
import { InstituteDetailsResponse } from '../../models/institute/instituteDetailResponse';
import { CommonInstituteDetailsResponse } from '../../models/institute/commonInstituteDetailsResponse';
import { InstituteUnderGraduateOrMastersDetailsResponse } from '../../models/institute/instituteUnderGraduateOrMastersDetailsResponse';
import { InstitutesMajorResponse } from '../../models/institute/institutesMajorResponse';
import { InstitutesCoursesResponse } from '../../models/institute/institutesCoursesResponse';
import { Currency, getCurrencyDescription } from '../../models/enums/UserRole';
import { GoogleMapsModule } from '@angular/google-maps';
import { InstituteDetailUsComponent } from "./institute-detail-us/institute-detail-us.component";
import { InstituteCommonDetailsV2Response } from '../../models/institute/instituteCommonDetailsV2Response';
import { InstituteMasterDetailsV2Response } from '../../models/institute/InstituteMasterDetailsV2Response';
import { InstituteUnderGraduateDetailsV2Response } from '../../models/institute/instituteUnderGraduateDetailsV2Response';
import { InstituteDetailUkComponent } from "./institute-detail-uk/institute-detail-uk.component";
import { InstituteDetailInComponent } from "./institute-detail-in/institute-detail-in.component";
import { InstituteDetailAuComponent } from "./institute-detail-au/institute-detail-au.component";
import { InstituteCourseCountByCourseLevelResponse } from '../../models/institute/instituteCourseCountByCourseLevelResponse';
import { InstituteCoursesV2Response } from '../../models/institute/instituteCoursesV2Response';
import { UserStateModel } from '../../states/user/user-state-model';
import { UserSelectors } from '../../states/user/user-selector';
import { AuthRoles } from '../../models/enums/enums';
import { CurrencyService } from '../../services/currency.service';


interface City {
  name: string;
  code: string;
}



@Component({
  selector: 'app-institute-detail',
  standalone: true,
  imports: [FormsModule, GoogleMapsModule, CheckboxModule, ImageModule,
    BreadcrumbModule, RouterModule, ChipModule, TooltipModule, AccordionModule,
    DropdownModule, ProgressBarModule, RatingModule, ScrollPanelModule, ChartModule,
    CommonModule, InstituteDetailUsComponent, InstituteDetailUkComponent, InstituteDetailInComponent, InstituteDetailAuComponent, SelectButtonModule],
  templateUrl: './institute-detail.component.html',
  styleUrl: './institute-detail.component.scss'
})
export class InstituteDetailComponent implements OnInit, AfterViewInit {

  @ViewChild('mapContainer') mapContainer: ElementRef | undefined;

  user!: UserStateModel;
  institute: InstituteCommonDetailsV2Response | undefined;
  coursesCount: InstituteCourseCountByCourseLevelResponse | undefined;
  instituteUGCourses: InstituteCoursesV2Response[] = [];
  instituteGraduateCourses: InstituteCoursesV2Response[] = [];
  instituteDoctoralCourses: InstituteCoursesV2Response[] = [];
  instituteUGMDetails!: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response;
  instituteCourses: InstitutesCoursesResponse[] | undefined;
  isLoading: boolean = false;
  showAllUGCourses = false;
  showAllPGCourses = false;
  showAllDoctoralCourses = false;

  center: google.maps.LatLngLiteral = {
    lat: 0,
    lng: 0
  }

  //----For Map Resizing----
  mapHeight = 0;
  mapWidth = 0;
  ngAfterViewInit(): void {
    if (this.mapContainer) {
      this.mapHeight = this.mapContainer.nativeElement.offsetHeight;
      this.mapWidth = this.mapContainer.nativeElement.offsetWidth;
      this.cdr.detectChanges();
    }
  }
  //----For Map Resizing----

  instituteId: string | null | undefined;
  isMyInstitute = true;
  totalInstituteInCountry: string = '';
  similarInstitutes: Institute[] | undefined;
  selectedProgramType: string = "Bachelor's Degree";
  displayCourses: boolean = false;
  portal: string = '';
  displayCurrency: Currency = Currency.Dollar;
  // currencyOptions = [
  //   { label: 'USD ($)', value: Currency.Dollar },
  //   { label: 'INR (₹)', value: Currency.Rupee }
  // ];
  currencyOptions = Object.values(Currency)
    .filter(v => typeof v === 'number')
    .map(v => ({
      label: getCurrencyDescription(v as Currency),
      value: v as Currency
    }));
  constructor(private instituteService: InstituteService,
    private route: ActivatedRoute,
    private store: Store,
    private messageService: MessageService,
    public currencyService: CurrencyService,
    private cdr: ChangeDetectorRef
  ) {
    this.displayCurrency = this.currencyService.getCurrency();
  }

  onCurrencyChange(event: any) {
    this.currencyService.setCurrency(event.value);
  }

  // getUser(){
  //   this.store.select(UserSelectors.getUser).subscribe({
  //     next: (response) => {
  //       this.user = response;
  //       if(this.user.role.includes(AuthRoles.Student)){
  //         this.portal = 'student';
  //       }else if(this.user.role.includes(AuthRoles.Mentor)){
  //         this.portal = 'mentor';
  //       }
  //     },
  //     error: (error) => {
  //       console.warn('Error fetching user:', error);
  //     }
  //   });
  // }

  get visibleUGCourses() {
    return this.showAllUGCourses ? this.instituteUGCourses : this.instituteUGCourses.slice(0, 3);
  }
  toggleUGCoursesView() {
    this.showAllUGCourses = !this.showAllUGCourses;
  }

  get visiblePGCourses() {
    return this.showAllPGCourses ? this.instituteGraduateCourses : this.instituteGraduateCourses.slice(0, 3);
  }
  togglePGCoursesView() {
    this.showAllPGCourses = !this.showAllPGCourses;
  }

  get visibleDoctoralCourses() {
    return this.showAllDoctoralCourses ? this.instituteDoctoralCourses : this.instituteDoctoralCourses.slice(0, 3);
  }
  toggleDoctoralCoursesView() {
    this.showAllDoctoralCourses = !this.showAllDoctoralCourses;
  }
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.instituteId = params.get('id')!; // Get the new ID from the route
      this.getInstituteCommonDetails();
      this.getUndergraduateOrMastersData();
      this.getSimilarInstitutes();
      this.getCoursesCount();
      this.getInstituteCourses();
      // this.getUser();
    });
  }
  getFullWebsiteURL(url: string): string {
    if (!url) return '';
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
  }

  getCoursesCount() {
    this.instituteService.getInstituteCourseCountByCourseLevel(this.instituteId!).subscribe({
      next: (response) => {
        this.coursesCount = response;
      }
    })
  }

  getInstituteCourses() {
    this.instituteService.listInstituteCoursesEndpoint({
      instituteId: this.instituteId!,
      searchText: '',
      courseLevel: "Bachelor's Degree"
    }).subscribe({
      next: (response) => {
        this.instituteUGCourses = response.result;
      }
    });
    this.instituteService.listInstituteCoursesEndpoint({
      instituteId: this.instituteId!,
      searchText: '',
      courseLevel: "Master's Degree"
    }).subscribe({
      next: (response) => {
        this.instituteGraduateCourses = response.result;
      }
    })
    this.instituteService.listInstituteCoursesEndpoint({
      instituteId: this.instituteId!,
      searchText: '',
      courseLevel: "Doctoral Degree"
    }).subscribe({
      next: (response) => {
        this.instituteDoctoralCourses = response.result;
      }
    })
  }
  displayCoursesTab() {
    this.displayCourses = true;
    this.selectedProgramType = '';
  }

  getCourseCurrencyCode(currency: number | null | undefined): string {
    switch (currency) {
      case Currency.Rupee:
        return 'INR';
      case Currency.Euro:
        return 'EUR';
      case Currency.Pound:
        return 'GBP';
      case Currency.Dollar:
      default:
        return 'USD';
    }
  }

  getAmount(currency: Currency, amount: any): string {
    const numericAmount = typeof amount === 'number' ? amount : parseFloat(amount?.toString() || '0');
    if (isNaN(numericAmount) || numericAmount === 0) return 'N/A';

    const currentDisplayCurrency = this.currencyService.getCurrency();
    const convertedAmount = this.currencyService.convertAmount(numericAmount, currency, currentDisplayCurrency);

    return `${getCurrencyDescription(currentDisplayCurrency)} ${Math.round(convertedAmount).toLocaleString()}`;
  }

  parsePercentage(percentageString: string | null): number {
    if (percentageString) {
      return parseFloat(percentageString.replace('%', ''));
    }
    return 0; // Return 0 if percentageString is null or undefined
  }

  setProgramType(type: string) {
    this.displayCourses = false;
    this.selectedProgramType = type;
    if (type !== 'Alumni') {
      this.getUndergraduateOrMastersData();
    }
  }

  onCoursesTabClick(programType: string) {
    this.selectedProgramType = programType;
    this.getInstituteCoursesList();
  }


  getUndergraduateOrMastersData() {
    if (this.selectedProgramType === "Bachelor's Degree") {
      this.instituteService.getInstituteUnderGraduateDetails(this.instituteId!).subscribe({
        next: (response) => {
          this.instituteUGMDetails = response;
          // this.prepareChartData();
        },
        error: (err) => {
          console.warn("Error loading UnderGraduateOrMasterDetails:", err)
        }
      })
    } else if (this.selectedProgramType === "Master's Degree") {
      this.instituteService.getInstituteMasterDetails(this.instituteId!).subscribe({
        next: (response) => {
          this.instituteUGMDetails = response;
          // this.prepareChartData();
        },
        error: (err) => {
          console.warn("Error loading UnderGraduateOrMasterDetails:", err)
        }
      })
    }
  }


  getInstituteCoursesList() {
    this.isLoading = true;
    this.instituteService.getInstitutesCourses({
      instituteId: this.instituteId!,
      type: this.selectedProgramType
    }).subscribe({
      next: (response) => {
        this.instituteCourses = response.result;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.warn("Error loading Institute Courses:", err);
      }
    })
  }

  getInstituteCommonDetails() {
    this.instituteService.getInstituteCommonDetails(this.instituteId!).subscribe({
      next: (response) => {
        this.institute = response;

        // ✅ ADD THIS: Facilities normalization
        if (!this.institute.facilities) {
          this.institute.facilities = {
            sportsFacilities: false,
            swimmingPool: false,
            gym: false
          };
        } else {
          this.institute.facilities.sportsFacilities = !!this.institute.facilities.sportsFacilities;
          this.institute.facilities.swimmingPool = !!this.institute.facilities.swimmingPool;
          this.institute.facilities.gym = !!this.institute.facilities.gym;
        }

        // ✅ Alumni normalization
        if (!this.institute.alumni) {
          this.institute.alumni = {
            hasInfluentialAlumni: false,
            influentialAlumni: [],
            hasAlumniInLeadershipRoles: false,
            alumniInLeadershipRoles: [],
            hasStartupFoundersFromCollege: false,
            startupFoundersFromCollege: []
          };
        } else {
          this.institute.alumni.hasInfluentialAlumni = !!this.institute.alumni.hasInfluentialAlumni;
          this.institute.alumni.hasAlumniInLeadershipRoles = !!this.institute.alumni.hasAlumniInLeadershipRoles;
          this.institute.alumni.hasStartupFoundersFromCollege = !!this.institute.alumni.hasStartupFoundersFromCollege;
          this.institute.alumni.influentialAlumni = this.institute.alumni.influentialAlumni || [];
          this.institute.alumni.alumniInLeadershipRoles = this.institute.alumni.alumniInLeadershipRoles || [];
          this.institute.alumni.startupFoundersFromCollege = this.institute.alumni.startupFoundersFromCollege || [];
        }

        this.center = {
          lat: this.institute.latitude ? parseFloat(this.institute.latitude) : 0,
          lng: this.institute.longitude ? parseFloat(this.institute.longitude) : 0,
        };
      },
      error: (err) => {
        console.warn("Error loading institute details: ", err)
      }
    });
  }

  toggleMyInstitute($event: string) {
    if (!this.isMyInstitute) {
      this.store.dispatch(new RemoveMyInstitute({ instituteId: $event ?? "", studentId: this.user.id })).subscribe({
        next: (response) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'College removed successfully' });
        },
        error: (error) => {
          console.warn(error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to remove college' });
        },
        complete: () => {

        }
      });
    }
    else {
      this.instituteService.getInstitute($event ?? "").subscribe({
        next: (response) => {
          this.store.dispatch(new AddMyInstitute({ item: response })).subscribe({
            next: (result) => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'College added successfully' });
            },
            error: (error) => {
              console.warn(error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add college' });
            },
            complete: () => {

            }
          });
        }
      })
    }
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  getSimilarInstitutes() {
    this.instituteService.getSimilarInstitutes(this.instituteId ?? '')
      .subscribe({
        next: (response) => {
          this.similarInstitutes = response.result
        },
        error: (err) => {
          console.warn(`error while retrieving similar:${err}`);
        }
      });
  }
}

